var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 409.6 356.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 284.71c1.8-17.94 11.76-32.23 20.89-46.91 9.64-15.49 19.19-31 28.78-46.56q48.74-78.87 97.42-157.75c8.47-13.74 19.7-24.21 35.07-29.49 31.33-10.7 62.18.28 79.73 28.52q50.63 81.48 100.83 163.2c5.48 8.88 3.55 18.56-4.46 23.4s-17.31 2.19-22.85-6.78q-50.12-81.06-100.14-162.18c-6.77-11-16.14-17.66-29.19-18.13-12.17-.43-22.32 4.3-29.09 14.46-8.28 12.41-15.89 25.25-23.73 37.94Q95.92 177.24 38.57 270c-8.12 13.13-9 26.25-.5 39.42 6 9.32 15 14.13 26 15.13.93.09 1.87.11 2.8.11h276.36c16.07 0 29-10.27 33.21-25.6 2.11-7.64.92-15-1.41-22.36-2.94-9.38 2.47-18.31 11.95-20.42a15.88 15.88 0 0 1 18.41 11.06c1.74 5.42 2.86 11 4.25 16.58v13.6c-.29 1-.54 2-.88 3-2.48 7.27-4 15.08-7.65 21.69-12.89 23.23-33.26 34.44-59.72 34.49q-69 .13-137.92 0c-45 0-90.09.15-135.13-.06-28.83-.14-49.95-13.2-62.21-39.47C3.21 311 2 304.08 0 297.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.81 162.89v58.38a15.33 15.33 0 0 1-8.57 14.31 15 15 0 0 1-15.94-.68c-5.26-3.36-7.48-8.42-7.47-14.6v-56c0-19.86-.08-39.71 0-59.57.07-11.81 10.55-19.58 21.17-15.92 6.72 2.32 10.77 8.22 10.79 16.09.05 19.34.02 38.67.02 57.99Zm-.02 114.76a16 16 0 1 1-15.91-16.11 16.09 16.09 0 0 1 15.91 16.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.871c585458114007953f7cff5320d0d2.svg";
export { ForwardRef as ReactComponent };